import { useState, useEffect } from 'react';
import ImageUpload from '../ImageUpload';
import { apiGet, apiPut } from '../api';

export default function FooterSection() {
  const [data, setData] = useState({
    logo_image: '',
    address_line1: '',
    address_line2: '',
    email: '',
    facebook_url: '',
    instagram_url: '',
    moacor_url: '',
    moacor_logo: '',
    copyright_text: '',
    privacy_policy_url: '',
    cookies_policy_url: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await apiGet('footer.php');
      setData(result);
    } catch (err) {
      setMessage('Erro ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      const result = await apiPut('footer.php', data);
      setMessage(result.success ? 'Salvo com sucesso!' : 'Erro ao salvar');
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Erro ao salvar dados');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Rodapé</h2>

      <div className="space-y-4">
        <ImageUpload
          currentImage={data.logo_image}
          onImageChange={(path) => setData({ ...data, logo_image: path })}
          label="Logo"
        />

        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Endereço</h3>
          <div className="space-y-2">
            <input
              type="text"
              value={data.address_line1}
              onChange={(e) => setData({ ...data, address_line1: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 1: Estrada Regional Ribeira Grande, 109"
            />
            <input
              type="text"
              value={data.address_line2}
              onChange={(e) => setData({ ...data, address_line2: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 2: 9500-702 PONTA DELGADA"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="bolacha@mulata.pt"
          />
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Redes Sociais</h3>
          <div className="space-y-2">
            <div>
              <label className="block text-sm text-gray-600 mb-1">Facebook</label>
              <input
                type="url"
                value={data.facebook_url}
                onChange={(e) => setData({ ...data, facebook_url: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.facebook.com/bolacha.mulata"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">Instagram</label>
              <input
                type="url"
                value={data.instagram_url}
                onChange={(e) => setData({ ...data, instagram_url: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/bolacha.mulata/"
              />
            </div>
          </div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg space-y-3">
          <h3 className="font-semibold text-gray-800 mb-3">Moaçor</h3>
          <div>
            <label className="block text-sm text-gray-600 mb-1">URL Moaçor</label>
            <input
              type="url"
              value={data.moacor_url}
              onChange={(e) => setData({ ...data, moacor_url: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="https://financor.pt/empresa/moacor/"
            />
          </div>
          
          <ImageUpload
            currentImage={data.moacor_logo}
            onImageChange={(path) => setData({ ...data, moacor_logo: path })}
            label="Logo Moaçor"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Texto de Copyright</label>
          <input
            type="text"
            value={data.copyright_text}
            onChange={(e) => setData({ ...data, copyright_text: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="©2026 FINANÇOR. TODOS OS DIREITOS RESERVADOS."
          />
        </div>
      </div>

      {message && (
        <div className={`p-4 rounded-lg ${message.includes('sucesso') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={isSaving}
        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50"
      >
        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </div>
  );
}
